// ENG-1068: box-select multiple nodes the Unreal / Blender way. Left-drag on
// empty canvas rubber-bands a selection (both DCCs do this: Blender's node
// keymap binds select_box to select_mouse CLICK_DRAG with tweak; Unreal's
// SNodePanel starts a marquee on an empty-canvas left-drag). Dragging a node
// still moves it; panning is the middle mouse button; Shift extends the
// selection.
//
// Interaction model, Blender-style:
//   • left-drag on empty canvas → box select
//   • drag a node               → move it
//   • MOUSE WHEEL               → zoom in / out (Blender's convention)
//   • middle-drag OR Space+left-drag → pan
//   • right-click               → menu
// Wheel zooms (zoomOnScroll stays React Flow's default true — we just don't
// turn it into pan). Panning is middle-drag or Space+drag: on a Mac trackpad
// with no middle button, hold Space and drag one finger. Right-button panning
// was tried and dropped — the browser fires `contextmenu` on right-release,
// stealing pointer capture so React Flow never gets the pointerup that ends the
// pan, and it stuck to the cursor.
//
// Spread onto every <ReactFlow> graph editor so they can't drift apart. Kept as
// a bare prop bag (no @xyflow import) — `selectionMode: 'partial'` is exactly
// SelectionMode.Partial's value, so it needs no enum.
export const GRAPH_MULTISELECT_PROPS = {
  selectionOnDrag: true,          // left-drag on the pane = box select
  panOnDrag: [1],                 // pan with the middle button (Space+drag also pans)
  selectionMode: 'partial',       // select nodes the box merely touches (DCC behaviour)
  multiSelectionKeyCode: 'Shift', // Shift-click / Shift-box extends the selection
  selectionKeyCode: null,         // no dedicated key — left-drag always selects
}
